// export link of backend url
// export const backendURL = 'http://localhost:5020';
 export const backendURL = 'https://fitness-leaf-ai-backend.onrender.com';
